import { Box } from '@mui/material';

import saraSrc from 'assets/images/svg/Sara.svg';
import saraCircleSrc from 'assets/images/svg/SaraCircle.svg';

export type SaraCircleMarkProps = {
    'aria-hidden'?: boolean;
    size?: number;
    /** `circle` = SaraCircle.svg; `sara` = full Sara.svg illustration */
    variant?: 'circle' | 'sara';
};

/**
 * Sara brand mark. Scales via `size` for header, transcript, FAB, etc.
 */
const SaraCircleMark = ({ 'aria-hidden': ariaHidden = true, size = 32, variant = 'circle' }: SaraCircleMarkProps) => (
    <Box
        alt=""
        aria-hidden={ariaHidden}
        component="img"
        src={variant === 'sara' ? saraSrc : saraCircleSrc}
        sx={{ width: size, height: size, display: 'block', flexShrink: 0 }}
    />
);

export default SaraCircleMark;
